import styled from 'styled-components';

export const LayoutContainer = styled.div`
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
`;

export const Topbar = styled.div`
    height: 60px;
    background: #ffffff;
    border-bottom: 1px solid #e2e8f0;
    display: flex;
    align-items: center;
    padding: 0 24px;
    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1);
    z-index: 1000;
    gap: 16px;
`;

export const Brand = styled.div`
    font-weight: bold;
    font-size: 18px;
    color: #1e293b;
    flex: 1;
`;

export const MainContent = styled.div`
    flex: 1;
    overflow: hidden;
`;
